import React from 'react';
import PropTypes from 'prop-types';
import logo from './logo192.png'; // Replace with actual path if needed

const BotMessage = ({ text, className = '' }) => {
    return (
        <div className={`d-flex align-items-start mb-1 ${className}`}>
            <img
                src={logo}
                alt="Chatbot avatar"
                className="me-2 rounded-circle"
                style={{ width: '35px', height: '35px' }}
            />
            <div className="bg-light text-dark p-1 rounded shadow-sm">
                <p className="m-0 small">{text}</p>
            </div>
        </div>
    );
};

BotMessage.propTypes = {
    text: PropTypes.string.isRequired,
    className: PropTypes.string,
};

export default BotMessage;
